/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendUserInviteDTO
 */
export interface SendUserInviteDTO {
    /**
     * 
     * @type {string}
     * @memberof SendUserInviteDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SendUserInviteDTO
     */
    nome: string;
    /**
     * 
     * @type {string}
     * @memberof SendUserInviteDTO
     */
    cognome: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendUserInviteDTO
     */
    ruoliProposti?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendUserInviteDTO
     */
    assistitoId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendUserInviteDTO
     */
    operatoreId?: string;
}

/**
 * Check if a given object implements the SendUserInviteDTO interface.
 */
export function instanceOfSendUserInviteDTO(value: object): value is SendUserInviteDTO {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('nome' in value) || value['nome'] === undefined) return false;
    if (!('cognome' in value) || value['cognome'] === undefined) return false;
    return true;
}

export function SendUserInviteDTOFromJSON(json: any): SendUserInviteDTO {
    return SendUserInviteDTOFromJSONTyped(json, false);
}

export function SendUserInviteDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendUserInviteDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'nome': json['nome'],
        'cognome': json['cognome'],
        'ruoliProposti': json['ruoliProposti'] == null ? undefined : json['ruoliProposti'],
        'assistitoId': json['assistitoId'] == null ? undefined : json['assistitoId'],
        'operatoreId': json['operatoreId'] == null ? undefined : json['operatoreId'],
    };
}

export function SendUserInviteDTOToJSON(value?: SendUserInviteDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'nome': value['nome'],
        'cognome': value['cognome'],
        'ruoliProposti': value['ruoliProposti'],
        'assistitoId': value['assistitoId'],
        'operatoreId': value['operatoreId'],
    };
}

